import moment from "moment-timezone";

import * as date from "@/utils/date";

import { RESET, SET_REQUIRED_END_DATE, SET_REQUIRED_START_DATE } from "./requiredDate.actionTypes";

export const setRequiredStartDate = (data) => (dispatch) => {
  dispatch({
    type: SET_REQUIRED_START_DATE,
    payload: data,
  });
};

export const setRequiredEndDate = (data) => (dispatch) => {
  dispatch({
    type: SET_REQUIRED_END_DATE,
    payload: data,
  });
};

export const setRequiredDates =
  ({ startDate, endDate }) =>
  (dispatch) => {
    const tz = date.getCurrentCompanyTimezone();

    dispatch(
      setRequiredStartDate(startDate ? moment.tz(startDate, tz).startOf("day").format() : null)
    );

    dispatch(setRequiredEndDate(endDate ? moment.tz(endDate, tz).endOf("day").format() : null));
  };

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};
